import { CheckCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Form, Steps } from 'antd';
import locale from 'antd/lib/locale/en_US';
import moment from 'moment';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../../../../redux/general/general-action';
import {
  DATE_FORMAT_YEAR_START_NO_TZ,
  DATE_PICKER_FORM,
  MODAL_TYPE
} from '../../../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import { RBHDatePicker } from '../../../../../../shared/components';
import RBHBox from '../../../../../../shared/components/rbh-box';
import RBHButton from '../../../../../../shared/components/rbh-button';
import RBHSteps from '../../../../../../shared/components/rbh-steps';
import RBHText from '../../../../../../shared/components/rbh-text';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import { Branch } from '../../../../../../shared/models/branch';
import { mainCreators } from '../../../../../main-action';
import { MAIN_STATE_KEY } from '../../../../../main-reducer';
import { BUTTON_FLAG, POS_REQUEST_ID_LIST } from '../../redux/pos-constant';
import { POS_STATE_KEY, posStateSelector } from '../../redux/pos-reducer';
import { posSagas } from '../../redux/pos-saga';
import { PosService } from '../../redux/pos-service';
import styles from '../styles';
import { posCreators } from '../../redux/pos-action';

export const PosStep4Screen: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const shopData = useSelector(posStateSelector(POS_STATE_KEY.POS_SHOP_DATA)) as Branch;
  const [selectedDate, setSelectedDate] = useState<any>(shopData?.posStartDate ? moment(shopData?.posStartDate) : undefined);
  const toPath = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(path);
  };

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    if (!!!shopData) {
      toPath('/main/posmanagement');
    }
  }, []);

  const resetForm = () => {
    setSelectedDate(undefined);
    form.setFieldsValue({
      calendarInput: undefined
    });
  };

  const updatePos = (body: any, pathName?: string) => {
    dispatch(httpCreators.request({
      service: PosService.updatePos,
      sagaHandler: posSagas.updatePosStep4Handler,
      id: POS_REQUEST_ID_LIST.PATCH_UPDATE_POS,
      callbackParams: { history, pathName, resetForm },
      serviceParams: body
    }));
  };

  const handleButtonCall = (buttonFlag?: string, path?: string) => {
    let body;
    const posStartDate = !!selectedDate ? moment(selectedDate).format(DATE_FORMAT_YEAR_START_NO_TZ) : null;
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
    if (buttonFlag === BUTTON_FLAG.LEAVE_STEP_4) {
      body = { shopId: shopData?.shopId, buttonFlag, posStartDate };
      updatePos(body, path);
    } else {
      // save this page button (no buttonFlag)
      body = { shopId: shopData?.shopId, posStartDate };
      updatePos(body, '/main/posmanagement');
    }
  };

  const disabledDate = (current: any) => {
    return current < moment().endOf('day') || current.isAfter(moment().add(30, 'd').endOf('day'));
  };

  const onChangeDate = (selected: any) => {
    setSelectedDate(selected);
  };

  const cancelPos = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImageId: 'cancelPos-alert-img',
      modalTitle: 'main.posManagement.posActivate.popup.cancelPos.header',
      modalTitleId: 'cancelPos-header-text',
      modalContent: 'main.posManagement.posActivate.popup.cancelPos.content',
      modalContentId: 'cancelPos-content-text',
      onOkText: 'main.posManagement.posActivate.popup.cancelPos.ok',
      onOkTextId: 'cancelPos-ok-text',
      onCancelText: 'main.posManagement.posActivate.popup.cancelPos.cancel',
      onCancelTextId: 'cancelPos-cancel-text',
      onConfirm: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
        dispatch(httpCreators.request({
          id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS,
          sagaHandler: posSagas.patchCancelPosHandler as any,
          service: PosService.patchCancelPos,
          serviceParams: { shopId: shopData.shopId },
          callbackParams: {
            alertCancelPosSuccess: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, true)),
            alertCancelPosFail: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, true)),
            toPath
          },
        }));
      },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'posmanagement-tohomepage-breadcrumb'}
              id={'posmanagement-tohomepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => !!!selectedDate ? toPath('/main') : dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.LEAVE_STEP_4, '/main'),
                onLeaveOnly: () => {
                  toPath('/main');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'branchmanagement-breadcrumb'}
              id={'branchmanagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => !!!selectedDate ? toPath('/main/branchmanagement') : dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.LEAVE_STEP_4, '/main/branchmanagement'),
                onLeaveOnly: () => {
                  toPath('/main/branchmanagement');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'posManagement-breadcrumb'}
              id={'posManagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => !!!selectedDate ? toPath('/main/posmanagement') : dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.LEAVE_STEP_4, '/main/posmanagement'),
                onLeaveOnly: () => {
                  toPath('/main/posmanagement');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.posManagement.landing.posManagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'posActivate-breadcrumb'}
              id={'posActivate-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.posManagement.breadcrumb.activate.pos'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'posActivate-step4-header'} id={'posActivate-step4-header'}
          style={styleText.headerText} text={'main.posManagement.breadcrumb.activate.pos'} />
        <RBHText data-testid={'cancel-posActivate-step4'} id={'cancel-posActivate-step4'}
          style={styles.regularPurple14under} text={'main.posManagement.posActivate.cancelActivatePos'}
          onClick={cancelPos} />
      </RBHBox>
    );
  };

  const posStepText = (step: number) => {
    if (step === 1) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step1-1'} id={'posActivate-step1-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.1'} />
          <RBHText data-testid={'posActivate-step1-2'} id={'posActivate-step1-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.2'} />
        </RBHBox>
      );
    } else if (step === 2) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step2-1'} id={'posActivate-step2-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step2'} />
        </RBHBox>
      );
    } else if (step === 3) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step3-1'} id={'posActivate-step3-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.1'} />
          <RBHText data-testid={'posActivate-step3-2'} id={'posActivate-step3-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.2'} />
        </RBHBox>
      );
    } else if (step === 4) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step4'} id={'posActivate-step4'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step4'} />
        </RBHBox>
      );
    }
  };

  const stepRender = () => {
    const { Step } = Steps;
    return (
      <RBHSteps current={3} type={'default'} className={'posStep'} style={styles.marginBottom20}>
        <Step style={styles.regular16fakeBlack} title={posStepText(1)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(2)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(3)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(4)} />
      </RBHSteps>
    );
  };

  const shopNameAndDescRender = () => {
    return (
      <RBHBox>
        <RBHBox style={{ display: 'flex' }}>
          <RBHText data-testid={'posActivate-shopNameLabel'} id={'posActivate-shopNameLabel'}
            style={styles.medium16fakeBlackTop} text={'main.posManagement.posActivate.shopNameLabel'} />&nbsp;
          <RBHText style={styles.regular16DarkGray}>{shopData?.shopName}</RBHText>
        </RBHBox>
        <RBHBox style={styles.line} />
      </RBHBox>
    );
  };

  const renderContent = () => {
    return (
      <RBHBox style={{ textAlign: 'center' }}>
        <CheckCircleOutlined data-testid={'icon-success'} id={'icon_success'} translate={null} style={styles.successIconImage} />
        <RBHText data-testid={'contentTitle'} id={'contentTitle'} style={styles.semiBold20FakeBlack}
          text={'main.posManagement.posActivate.step4.contentTitle'} />
        <RBHText data-testid={'contentDetail'} id={'contentDetail'} style={styles.regular16DarkGray}
          text={'main.posManagement.posActivate.step4.contentDetail'} />
        <RBHText data-testid={'contentDetail2'} id={'contentDetail2'} style={styles.regular16DarkGray}
          text={'main.posManagement.posActivate.step4.contentDetail2'} />
        <RBHBox style={styles.calendarContainer}>
          <Form
            size={'large'}
            form={form}
            style={styles.formText}>
            <ConfigProvider locale={locale}>
              <Form.Item name={'calendarInput'} colon={false} validateTrigger={['onChange', 'onBlur']}
                initialValue={selectedDate}
                rules={[
                  { required: true, message: <FormattedMessage id={'main.form.required2'} /> }
                ]}>
                <RBHDatePicker
                  allowClear={false}
                  showToday={false}
                  name={'calendarInput'}
                  style={styles.calendarInput}
                  data-testid={'calendarInput'}
                  id={'calendarInput'}
                  format={DATE_PICKER_FORM}
                  onChange={onChangeDate}
                  autoComplete={'off'}
                  disabledDate={disabledDate}
                  placeholder={'main.posManagement.posActivate.step4.calendarPlaceholder'} />
              </Form.Item>
            </ConfigProvider>
          </Form>
        </RBHBox>
      </RBHBox >
    );
  };

  const buttonsRender = () => {
    return (
      <RBHBox style={styles.boxButtonStep4}>
        <RBHButton
          id={'posActivate-buttonSaveThisPage'}
          style={styles.buttonFromConfirmGradient}
          type={'primary'}
          htmlType={'button'}
          onClick={handleButtonCall}
          disabled={!!!selectedDate}
          text={'main.posManagement.posActivate.buttonSaveThisPage'}
          data-testid={'posActivate-buttonSaveThisPage'} />
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {BreadcrumbRender()}
      <RBHBox>
        {headerRender()}
        {stepRender()}
        <RBHBox>
          <RBHBox style={styles.defaultContent}>
            {shopNameAndDescRender()}
            {renderContent()}
          </RBHBox>
          {buttonsRender()}
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};
